"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionReducers = void 0;
var tslib_1 = require("tslib");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var selectionSelectors_1 = require("./selectionSelectors");
var changeSelection = function (state, action) {
    state.selection.working.keys = action.payload.selection;
    if (!isNil_1.default(action.payload.isInverted)) {
        state.selection.working.isInverted = action.payload.isInverted;
    }
};
var revertSelection = function (state) {
    var committedSelection = selectionSelectors_1.selectCommittedSelection(state);
    var isCommittedSelectionInverted = selectionSelectors_1.selectIsCommittedSelectionInverted(state);
    state.selection.working.keys = committedSelection;
    state.selection.working.isInverted = isCommittedSelectionInverted;
};
var commitSelection = function (state) {
    var workingSelection = selectionSelectors_1.selectWorkingSelection(state);
    var isWorkingSelectionInverted = selectionSelectors_1.selectIsWorkingSelectionInverted(state);
    state.selection.commited.keys = workingSelection;
    state.selection.commited.isInverted = isWorkingSelectionInverted;
};
var invertSelection = function (state) {
    var isWorkingSelectionInverted = selectionSelectors_1.selectIsWorkingSelectionInverted(state);
    state.selection.working.isInverted = !isWorkingSelectionInverted;
};
var clearSelection = function (state) {
    state.selection.working.keys = [];
};
/**
 * @internal
 */
exports.selectionReducers = {
    changeSelection: changeSelection,
    revertSelection: revertSelection,
    commitSelection: commitSelection,
    invertSelection: invertSelection,
    clearSelection: clearSelection,
};
//# sourceMappingURL=selectionReducers.js.map